import Hero from '@/components/Hero';
import ContactForm from '@/components/ContactForm';
import { MapPin, Phone, Mail, Clock, MessageCircle, Facebook, Instagram } from 'lucide-react';
const Contact = () => {
  return <div className="min-h-screen">
      {/* Hero */}
      <Hero title="צור קשר" subtitle="נשמח לשמוע מכם ולעזור בכל שאלה" image="https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=80&w=1000&auto=format&fit=crop" height="medium" />

      {/* Contact Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            {/* Contact Information */}
            <div className="md:col-span-4 space-y-8">
              <div>
                <h2 className="text-3xl font-light mb-8">פרטי התקשרות</h2>
                <p className="text-gray-600 mb-8">
                  אנו זמינים לענות על כל שאלה ולהעניק ייעוץ ראשוני ללא התחייבות. 
                  ניתן ליצור קשר באמצעות הטופס או באחת מהדרכים הבאות:
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start">
                  <MapPin size={20} className="ml-4 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-medium mb-1">כתובת</h3>
                    <p className="text-gray-600">ביג פאשן גלילות, כביש החוף, רמת השרון</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Phone size={20} className="ml-4 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-medium mb-1">טלפון</h3>
                    <p className="text-gray-600">
                      <a href="tel:+97231234567" className="hover:text-black transition-colors">03-3752886</a>
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Mail size={20} className="ml-4 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-medium mb-1">אימייל</h3>
                    <p className="text-gray-600">
                      <a href="mailto:info@benzur.co.il" className="hover:text-black transition-colors">office@szlaw.co.il</a>
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Clock size={20} className="ml-4 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-medium mb-1">שעות פעילות</h3>
                    <p className="text-gray-600">ימים א'-ה': 9:00-18:00</p>
                    <p className="text-gray-600">יום ו': 9:00-13:00</p>
                  </div>
                </div>
              </div>

              {/* WhatsApp Button */}
              <a
                href="https://wa.me/972543015571?text=שלום,%20אשמח%20לקבל%20מידע%20נוסף"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 w-full bg-[#25D366] hover:bg-[#128C7E] text-white font-medium py-3 px-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg"
              >
                <MessageCircle size={20} />
                <span>מענה מיידי בוואטסאפ - לחצו כאן</span>
              </a>

              {/* Social Media Links */}
              <div className="pt-4 border-t border-gray-200">
                <h3 className="font-medium mb-4 text-center">עקבו אחרינו</h3>
                <div className="flex justify-center gap-6">
                  <a
                    href="https://www.facebook.com/profile.php?id=61581894786315&mibextid=wwXIfr&rdid=khDbBeSPvVMfax7T&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1KS1edbGsC%2F%3Fmibextid%3DwwXIfr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-12 h-12 rounded-full bg-[#1877F2] hover:bg-[#0d5dbf] text-white transition-colors shadow-md hover:shadow-lg"
                    aria-label="Facebook"
                  >
                    <Facebook size={24} />
                  </a>
                  <a
                    href="https://www.instagram.com/sz_lawyers?igsh=MWU2YjRybW0yMDhqaQ%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] hover:opacity-90 text-white transition-opacity shadow-md hover:shadow-lg"
                    aria-label="Instagram"
                  >
                    <Instagram size={24} />
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div id="contact-form" className="md:col-span-8">
              <h2 className="text-3xl font-light mb-8">שלח הודעה</h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="h-[400px] w-full bg-gray-200 relative">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3381.0992355646635!2d34.7746833!3d32.073928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d4b82a6148a07%3A0x8d2d84267306c6c6!2z15jXnCDXkNeR15nXkQ!5e0!3m2!1siw!2sil!4v1642513990937!5m2!1siw!2sil" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" title="מפת מיקום המשרד"></iframe>
      </section>
    </div>;
};
export default Contact;